export const INVOICE_QUERY_KEYS = {
  INVOICE_DEFAULT_MESSAGES: 'invoiceDefaultMessages',
  INVOICE_DEFAULT_CUSTOMER_VIEWS: 'invoiceDefaultCustomerViews',
  INVOICE_DEFAULT_PAYMENT_OPTIONS: 'invoiceDefaultPaymentOptions',
  INVOICE_FLAGS: 'invoiceFlags',
  JOB_INVOICES: 'jobInvoices',
  INVOICE_PREVIEW: 'invoicePreview',
  INVOICE_COMMUNICATION_DEFAULTS: 'invoiceCommunicationDefaults',
  PAYMENT_SUGGESTIONS: 'paymentSuggestions',
  INVOICE_HTML: 'invoiceHtml',
  INVOICE_DATA: 'invoiceData',
  PAYMENTS_STATUS: 'paymentsStatus',
  INVOICES_LIST_VIEW: 'invoicesListView',
};
